export default function Comparison() {
  const cardboardIssues = [
    'Buy boxes',
    'Tape boxes',
    'Boxes collapse',
    'Throw them away',
    'Clutter everywhere'
  ];

  const boxFreeBenefits = [
    'Delivered to your door',
    'No tape required',
    'Stackable and durable',
    'Reusable and eco friendly',
    'We pick them up when you\'re done'
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Why BoxFreeMove</h2>
          <p className="text-lg text-gray-600">
            See the difference for yourself
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Cardboard Boxes */}
          <div className="bg-gray-100 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gray-300 rounded-lg flex items-center justify-center">
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Cardboard Boxes</h3>
            </div>
            <div className="w-full h-52 rounded-xl overflow-hidden mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/6c9c7ce41f6af237f8fa4e9168b40b50.jpg"
                alt="Person struggling with cardboard boxes and tape"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <ul className="space-y-4">
              {cardboardIssues.map((issue, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-close-circle-fill text-xl text-red-500 mt-0.5"></i>
                  <span className="text-gray-700">{issue}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* BoxFreeMove Totes */}
          <div className="bg-yellow-50 rounded-2xl p-8 ring-2 ring-yellow-400">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-yellow-400 rounded-lg flex items-center justify-center">
                <i className="ri-checkbox-circle-line text-2xl text-gray-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">BoxFreeMove Totes</h3>
            </div>
            <div className="w-full h-52 rounded-xl overflow-hidden mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=happy%20smiling%20person%20standing%20next%20to%20neatly%20stacked%20black%20plastic%20moving%20totes%20containers%20with%20bright%20yellow%20lids%20handles%20clean%20modern%20home%20interior%20organized%20efficient%20packing%20system%20satisfied%20customer%20reusable%20eco%20friendly%20moving%20boxes%20black%20body%20yellow%20lid%20stackable%20totes%20bright%20natural%20light&width=800&height=500&seq=hero-after-001&orientation=landscape"
                alt="Happy person with black moving totes with yellow lids"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <ul className="space-y-4">
              {boxFreeBenefits.map((benefit, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-xl text-green-500 mt-0.5"></i>
                  <span className="text-gray-900 font-medium">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
